import { render, staticRenderFns } from "./BrandProtectionSettings.vue?vue&type=template&id=73745b14&scoped=true"
import script from "./BrandProtectionSettings.vue?vue&type=script&lang=js"
export * from "./BrandProtectionSettings.vue?vue&type=script&lang=js"
import style0 from "./BrandProtectionSettings.vue?vue&type=style&index=0&id=73745b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73745b14",
  null
  
)

export default component.exports